import { render, staticRenderFns } from "./bid-request-epc-leader.vue?vue&type=template&id=dc6cfa08&scoped=true"
import script from "./bid-request-epc-leader.vue?vue&type=script&lang=js"
export * from "./bid-request-epc-leader.vue?vue&type=script&lang=js"
import style0 from "./bid-request-epc-leader.vue?vue&type=style&index=0&id=dc6cfa08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6cfa08",
  null
  
)

export default component.exports